// extracted by mini-css-extract-plugin
module.exports = {"body":"checkMail_body__2p8jG","container":"checkMail_container__3_fqL","text":"checkMail_text__39mV_"};